<img [src]="userImageURL" [ngClass]="imageClass" />